var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangJp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 33,
    viewBox: "0 0 69 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1001 20.3999H50.3V21.8999H53.1001V20.3999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3999 19.7002H33.6001V15.2002C33.0001 16.9002 32.2999 18.4002 31.3999 19.7002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 20.6001H44.6001V21.8001H45.8V20.6001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 13.3999H17.3V15.9999H23.3V13.3999Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 0.600098H17.1001C8.2001 0.600098 0.899902 7.8001 0.899902 16.8001C0.899902 25.8001 8.1001 33.0001 17.1001 33.0001H52.5C61.4 33.0001 68.7 25.8001 68.7 16.8001C68.7 7.8001 61.4 0.600098 52.5 0.600098ZM25.5 24.0001H23.2V23.0001H17.2V24.0001H15V11.3001H25.3999V24.0001H25.5ZM39.8999 22.0001C39.3999 21.6001 39.0001 21.2001 38.6001 20.6001V21.8001H35.8V24.1001H33.6001V21.8001H30.8V20.5001C30.4 21.1001 29.9 21.6001 29.3 22.0001C28.9 21.5001 28.2 20.7001 27.8 20.3001C29.4 19.2001 30.7 17.2001 31.5 15.2001H28.3999V13.1001H33.7V10.4001H35.8999V13.1001H41.2V15.2001H38C38.8 17.1001 40.1001 19.0001 41.6001 20.1001C41.0001 20.6001 40.2999 21.4001 39.8999 22.0001ZM42.3 12.8001H44.6001C44.4001 12.3001 44.1 11.6001 43.8 11.1001L45.3999 10.3001C45.7999 10.9001 46.1999 11.7001 46.3999 12.3001L45.5 12.8001H47.8999V14.4001H42.2V12.8001H42.3ZM42.8999 16.5001V14.9001H47.5V16.5001H42.8999ZM47.5 16.9001V18.5001H42.8999V16.9001H47.5ZM47.6001 23.4001H44.7V24.0001H42.8999V18.9001H47.6001V23.4001ZM55.2 24.1001H53.2V23.7001H50.3999V24.2001H48.5V18.7001H55.3V24.1001H55.2ZM55.8999 18.1001H47.7V16.4001H49.3C49.4 16.0001 49.5 15.6001 49.5 15.1001H48.3999V13.4001H49.8C49.8 13.1001 49.8999 12.9001 49.8999 12.6001H48V11.0001H55.5V12.7001H51.8999L51.8 13.5001H54.7V16.4001H55.8999V18.1001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3 18.1001H17.3V20.9001H23.3V18.1001Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8 19.7003H37.8999C36.9999 18.4003 36.3 16.9003 35.8 15.3003V19.7003Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 16.4001H52.8V15.1001H51.5C51.5 15.6001 51.4 16.0001 51.3 16.4001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangJp);
export default __webpack_public_path__ + "static/media/lang-jp.17dd31520d1cc968537e6564af4eaef6.svg";
export { ForwardRef as ReactComponent };